import React, { useState } from 'react';
import { NavLink as Link, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import SideBar from '../SideBar';
import Content from './components/Content';
import NotificationBell from './components/NotificationBell';

import logo from '../../assets/img/black-logo.png';
import user from '../../assets/img/sheep-black.jpeg';
import logoMobile from '../../assets/img/black-logo.png';

import {
  Container,
  MenuIcon,
  Row,
  Options,
  Item,
  Logo,
  Button,
  UserPhoto,
  ContainerOnlyAppearsVersionMobile,
} from './styles';

const Header = ({ showShopLink }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showSideBar, setShowSideBar] = useState(false);
  const token = useSelector((state) => state.User.accessToken);
  const userPhoto = useSelector((state) => state.User.avatar_url);

  console.log(useSelector((state) => state.User))

  function renderUserPhoto() {
    if (userPhoto === '' || userPhoto === null || userPhoto === undefined) {
      return <UserPhoto src={user} alt="Foto do usuário" />;
    }
    return <UserPhoto src={userPhoto} alt="Foto do usuário" />;
  }

  function renderLoginButton() {
    if (!token) {
      return (
        <Button>
          <Link to="/login">Entrar</Link>
        </Button>
      );
    }
  }

  const logout = () => {
    dispatch({ type: 'yoga-adm/user/logout' });
    history.push('/');
  };

  return (
    <Container className="header">
      <SideBar visible={showSideBar} setVisible={setShowSideBar} />
      <Content>
        <Row>
          <MenuIcon
            className="header__menu-icon"
            onClick={() => setShowSideBar(true)}
          >
            <div/>
            <div/>
            <div/>
          </MenuIcon>
          <Logo onClick={() => history.push('/')} src={logo} alt="Worsheep" style={{ width: '10rem', height: 'auto' }} />
          <ContainerOnlyAppearsVersionMobile onClick={() => history.push('/')}>
            <img src={logoMobile} alt="Worsheep" />
          </ContainerOnlyAppearsVersionMobile>
        </Row>

        <Options>
          {token && (
            <Item>
              <Link activeClassName='active' to="/assistidos">Histórico</Link>
            </Item>
          )}

          {token && (
            <Item>
              <Link activeClassName='active' to="/favoritos">Favoritos</Link>
            </Item>
          )}

          {showShopLink && (
            <Item>
              <Link to="/escolha-um-plano">Planos</Link>
            </Item>
          )}

          {/* <Item>
            <Link to="/download">Baixar</Link>
          </Item> */}

          {!token && (
            <Item>
              <Link to="/escolha-um-plano">Cadastre-se</Link>
            </Item>
          )}
        </Options>
        <Row>
          {renderLoginButton()}

          {token && <NotificationBell />}

          {token && (
            <div className="user">
              {renderUserPhoto()}

              <div className="user__options">
                <Link to="/perfil" className="user__config">
                  Configurações
                </Link>
                <span className="user__logout" onClick={() => logout()}>
                  Sair
                </span>
              </div>
            </div>
          )}
        </Row>
      </Content>
    </Container>
  );
};

export default Header;
